export function linear(from: Float32Array, to: Float32Array, t: number): Float32Array {
  const result = new Float32Array(from.length);
  for (let i = 0; i < from.length; i++) {
    result[i] = from[i] + t * (to[i] - from[i]);
  }
  return result;
}

export function slerp(from: Float32Array, to: Float32Array, t: number): Float32Array {
  let dot = 0;
  let fromNorm = 0;
  let toNorm = 0;

  for (let i = 0; i < from.length; i++) {
    dot += from[i] * to[i];
    fromNorm += from[i] * from[i];
    toNorm += to[i] * to[i];
  }

  fromNorm = Math.sqrt(fromNorm);
  toNorm = Math.sqrt(toNorm);

  if (fromNorm === 0 || toNorm === 0) {
    return linear(from, to, t);
  }

  dot = dot / (fromNorm * toNorm);
  dot = Math.max(-1, Math.min(1, dot));
  const omega = Math.acos(dot);

  if (Math.abs(omega) < 1e-6) {
    return linear(from, to, t);
  }

  const sinOmega = Math.sin(omega);
  const w1 = Math.sin((1 - t) * omega) / sinOmega;
  const w2 = Math.sin(t * omega) / sinOmega;

  const result = new Float32Array(from.length);
  for (let i = 0; i < from.length; i++) {
    result[i] = w1 * from[i] + w2 * to[i];
  }
  return result;
}

export function interpolatePath(
  from: Float32Array,
  to: Float32Array,
  steps: number,
  method: 'linear' | 'spherical'
): Float32Array[] {
  const path: Float32Array[] = [];
  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    path.push(method === 'spherical' ? slerp(from, to, t) : linear(from, to, t));
  }
  return path;
}
